






















































import { Component, Vue, Prop } from 'vue-property-decorator'
import api, { NotAuthenticated } from '@/services/api'
import chat from '@/services/chat'
import { VueMasonryPlugin } from 'vue-masonry'
Vue.use(VueMasonryPlugin)

@Component({
    watch: {
        category(to, from) {
            ;(this as any).loadCategory(to)
        },
    },
})
export default class extends Vue {
    @Prop()
    category: string[]
    loading = false
    skip = 0
    loadedAll = false;

    videos: any[] = []
    created() {
        this.loadCategory(this.category)
    }
    async loadCategory(category: string[]) {
        this.loading = true
        this.videos = []
        this.skip = 0
        this.loadedAll = false;

        this.loadVideos()
    }
    async loadVideos() {
        this.loading = true
        const videos = await this.getGifs(this.category, this.skip)
        console.log('videos.skip + videos.data.length', videos.skip + videos.data.length, 'videos.total', videos.total)
        if (videos.skip + videos.data.length >= videos.total) {
            this.loadedAll = true
        }
        for (const video of videos.data) {
            this.videos.push(video)
        }
        this.loading = false
    }
    async getGifs(category: string[], skip: number) {
        if (category.length === 0) {
            return []
        }
        // const gifs = await api.service('gifs').find({
        //     query: {
        //         $limit: 15,
        //         $skip: skip,
        //         category: {
        //             $in: category,
        //         },
        //     },
        // })
        const gifs = await api.request('GET', `gifs?$limit=15&$skip=${skip}&category[$in]=fmasturbation&category[$in]=null`)
        //  {
        //     query: {
        //         $limit: 15,
        //         $skip: skip,
        //         category: {
        //             $in: category,
        //         },
        //     },
        // }
        console.log(gifs)
        return gifs
    }
    async sendVideo(video: any) {
        chat.sendMessage(undefined, [
            {
                t: 'v',
                d: video._id,
            },
        ])
        this.$router.push('/chat')
    }
    async loadMore() {
        if (this.loadedAll) {
            return;
        }
        console.log('load omre', this.loadedAll)
        if (this.loading === false) {
            this.skip += 15
            this.loadVideos()
        }
    }
}
